<template>
  <div class="d-inline">
    <span
      v-ripple
      class="pa-0 d-flex theme--light v-size--default align-center"
      style="cursor: pointer"
      @click="detailStyleOption = !detailStyleOption"
    >
      詳細スタイル設定
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>{{
          detailStyleOption ? 'mdi-chevron-up' : 'mdi-chevron-down'
        }}</v-icon>
      </v-btn>
    </span>
    <v-expand-transition>
      <div v-show="detailStyleOption" class="pt-2 px-1">
        <span class="d-block caption v-label theme--light">形</span>
        <div class="row px-1" style="width: 100%">
          <v-select
            class="col-5"
            :value="editingItemable.type"
            :items="buttonTypes"
            item-text="name"
            item-value="value"
            :rules="[presenceValidation]"
            @input="updateEditingItemable($event, 'type')"
          >
            <template v-slot:label>
              <InputLabel label-name="形" :required="true" />
            </template>
          </v-select>
          <v-select
            class="col-7 px-0"
            :value="editingItemable.sizeType"
            :items="sizeType"
            item-text="name"
            item-value="value"
            :rules="[presenceValidation]"
            @input="updateEditingItemable($event, 'sizeType')"
          >
            <template v-slot:label>
              <InputLabel label-name="横幅" :required="true" />
            </template>
          </v-select>
        </div>
        <span class="d-block caption v-label theme--light">ラベル</span>
        <div class="px-1 row" style="width: 100%">
          <v-select
            class="col-xl-5 col-12"
            :value="editingItemable.labelType"
            :items="labelTypes"
            item-text="name"
            item-value="value"
            label="形式"
            @input="updateEditingItemable($event, 'labelType')"
            clearable
          />
          <v-text-field
            class="col-xl-7 col-12 px-xl-0"
            block
            :value="editingItemable.labelText"
            @input="updateEditingItemable($event, 'labelText')"
          >
            <template v-slot:label>
              <InputLabel label-name="テキスト" :required="false" />
            </template>
          </v-text-field>
        </div>
        <span class="d-block caption v-label theme--light">グラデーション</span>
        <v-text-field
          class="px-1"
          block
          placeholder='#FFFFFF'
          :rules='[colorCodeValidation(true)]'
          :value="editingItemable.gradientColor"
          @input="updateEditingItemable($event, 'gradientColor')"
          clearable
        >
          <template v-slot:label>
            <InputLabel label-name="比較色" :required="false" />
          </template>
          <template v-slot:append-outer>
            <ColorPickerMenu
              :color-code="editingItemable.gradientColor"
              @change-color-code="
                updateEditingItemable($event, 'gradientColor')
              "
            />
          </template>
        </v-text-field>
        <span class="d-block caption v-label theme--light">角</span>
        <v-select
          class="px-1"
          :value="editingItemable.radius"
          :items="radiusTypes"
          item-text="name"
          item-value="value"
          :rules="[presenceValidation]"
          @input="updateEditingItemable($event, 'radius')"
        >
          <template v-slot:label>
            <InputLabel label-name="丸み" :required="true" />
          </template>
        </v-select>
        <span class="d-block caption v-label theme--light">内側の余白</span>
        <div class="row px-1" style="width: 100%">
          <v-text-field
            class="col-6"
            suffix="px"
            type="number"
            :rules="[moreThanMinimumNumberValidation(0)]"
            :min="0"
            block
            :value="paddingX"
            @input="updateEditingItemable(stringToNumber($event), 'padding', 'x')"
          >
            <template v-slot:label>
              <InputLabel label-name="左右"/>
            </template>
          </v-text-field>
          <v-text-field
            class="col-6"
            suffix="px"
            type="number"
            :rules="[moreThanMinimumNumberValidation(0)]"
            :min="0"
            block
            :value="paddingY"
            @input="updateEditingItemable(stringToNumber($event), 'padding', 'y')"
          >
            <template v-slot:label>
              <InputLabel label-name="上下"/>
            </template>
          </v-text-field>
        </div>
        <span class="d-block caption v-label theme--light">影</span>
        <div class="px-1 row" style="width: 100%">
          <v-text-field
            class="col-xl-3 col-6 pr-1"
            suffix="px"
            type="number"
            block
            :value="boxShadowX"
            @input="updateEditingItemable(stringToNumber($event), 'boxShadow', 'x')"
            label="左右"
          >
          </v-text-field>
          <v-text-field
            class="col-xl-3 col-6 pr-1"
            suffix="px"
            type="number"
            block
            :value="boxShadowY"
            @input="updateEditingItemable(stringToNumber($event), 'boxShadow', 'y')"
            label="上下"
          >
          </v-text-field>
          <v-text-field
            class="col-xl-3 col-6 pr-1"
            suffix="px"
            type="number"
            block
            :value="boxShadowBlur"
            @input="updateEditingItemable(stringToNumber($event), 'boxShadow', 'blur')"
            label="ぼかし"
          >
          </v-text-field>
          <v-text-field
            class="col-xl-3 col-6 pr-1"
            suffix="px"
            type="number"
            block
            :value="boxShadowSpread"
            @input="updateEditingItemable(stringToNumber($event), 'boxShadow', 'spread')"
            label="広がり"
          >
          </v-text-field>
        </div>
        <span class="d-block caption v-label theme--light">枠線</span>
        <div class="px-1 row" style="width: 100%">
          <span class="col-2 d-block body-1 v-label theme--light mt-3">
            上
          </span>
          <v-text-field
            class="col-5 pr-1"
            type="number"
            block
            :value="borderTop.size"
            @input="updateEditingItemable(stringToNumber($event), 'border', 'top', 'size')"
            label="太さ"
            suffix="px"
          />
          <v-text-field
            class="col-5 pr-1"
            block
            placeholder='#FFFFFF'
            :rules='[colorCodeValidation(true)]'
            :value="borderTop.color"
            @input="updateEditingItemable($event, 'border', 'top', 'color')"
            label="色"
          >
            <template v-slot:append-outer>
              <ColorPickerMenu
                :color-code="borderTop.color"
                @change-color-code="
                  updateEditingItemable($event, 'border', 'top', 'color')
                "
              />
            </template>
          </v-text-field>
        </div>
        <div class="row" style="width: 100%">
          <span class="col-2 d-block body-1 v-label theme--light mt-3">
            右
          </span>
          <v-text-field
            class="col-5 pr-1"
            type="number"
            block
            :value="borderRight.size"
            @input="updateEditingItemable(stringToNumber($event), 'border', 'right', 'size')"
            label="太さ"
            suffix="px"
          />
          <v-text-field
            class="col-5 pr-1"
            block
            placeholder='#FFFFFF'
            :rules='[colorCodeValidation(true)]'
            :value="borderRight.color"
            @input="updateEditingItemable($event, 'border', 'right', 'color')"
            label="色"
          >
            <template v-slot:append-outer>
              <ColorPickerMenu
                :color-code="borderRight.color"
                @change-color-code="
                  updateEditingItemable($event, 'border', 'right', 'color')
                "
              />
            </template>
          </v-text-field>
        </div>
        <div class="row" style="width: 100%">
          <span class="col-2 d-block body-1 v-label theme--light mt-3">
            下
          </span>
          <v-text-field
            class="col-5 pr-1"
            type="number"
            block
            :value="borderBottom.size"
            @input="updateEditingItemable(stringToNumber($event), 'border', 'bottom', 'size')"
            label="太さ"
            suffix="px"
          />
          <v-text-field
            class="col-5 pr-1"
            block
            placeholder='#FFFFFF'
            :rules='[colorCodeValidation(true)]'
            :value="borderBottom.color"
            @input="updateEditingItemable($event, 'border', 'bottom', 'color')"
            label="色"
          >
            <template v-slot:append-outer>
              <ColorPickerMenu
                :color-code="borderBottom.color"
                @change-color-code="
                  updateEditingItemable($event, 'border', 'bottom', 'color')
                "
              />
            </template>
          </v-text-field>
        </div>
        <div class="row" style="width: 100%">
          <span class="col-2 d-block body-1 v-label theme--light mt-3">
            左
          </span>
          <v-text-field
            class="col-5 pr-1"
            type="number"
            block
            :value="borderLeft.size"
            @input="updateEditingItemable(stringToNumber($event), 'border', 'left', 'size')"
            label="太さ"
            suffix="px"
          />
          <v-text-field
            class="col-5 pr-1"
            block
            placeholder='#FFFFFF'
            :rules='[colorCodeValidation(true)]'
            :value="borderLeft.color"
            @input="updateEditingItemable($event, 'border', 'left', 'color')"
            label="色"
          >
            <template v-slot:append-outer>
              <ColorPickerMenu
                :color-code="borderLeft.color"
                @change-color-code="
                  updateEditingItemable($event, 'border', 'left', 'color')
                "
              />
            </template>
          </v-text-field>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'
import ButtonItemPreview from '../previews/ButtonItemPreview'
import ButtonItemFormPreview from './ButtonItemFormPreview'
import ColorPickerMenu from '@/components/commons/ColorPickerMenu'
import BaseForm from './BaseForm'

export default {
  name: 'DetailForm',
  components: {
    BaseForm,
    ColorPickerMenu,
    ButtonItemFormPreview,
    ButtonItemPreview,
    InputLabel
  },
  mixins: [itemUtilsMixin, formValidationUtils],
  data () {
    return {
      detailStyleOption: false,
      buttonTypes: [
        {
          value: 'rectangle',
          name: '長方形'
        },
        {
          value: 'square',
          name: '正方形'
        }
      ],
      sizeType: [
        {
          value: 'auto_adjustment',
          name: '小'
        },
        {
          value: 'btn_big',
          name: '大'
        },
        {
          value: 'btn_x_big',
          name: '特大'
        }
      ],
      labelTypes: [
        {
          value: 'speech_bubble',
          name: '吹き出し'
        },
        {
          value: 'top_left_quadrangle',
          name: '四角小'
        },
        {
          value: 'quadrangle',
          name: '四角大'
        }
      ],
      radiusTypes: [
        {
          value: '0',
          name: 'なし'
        },
        {
          value: '3px',
          name: '角丸'
        },
        {
          value: '50px',
          name: '角丸大'
        },
        {
          value: '50%',
          name: '最大'
        }
      ]
    }
  },
  computed: {
    paddingX () {
      return this.editingItemable.padding
        ? this.editingItemable.padding.x
        : 0
    },
    paddingY () {
      return this.editingItemable.padding
        ? this.editingItemable.padding.y
        : 0
    },
    boxShadowX () {
      return this.editingItemable.boxShadow
        ? this.editingItemable.boxShadow.x
        : null
    },
    boxShadowY () {
      return this.editingItemable.boxShadow
        ? this.editingItemable.boxShadow.y
        : null
    },
    boxShadowBlur () {
      return this.editingItemable.boxShadow
        ? this.editingItemable.boxShadow.blur
        : null
    },
    boxShadowSpread () {
      return this.editingItemable.boxShadow
        ? this.editingItemable.boxShadow.spread
        : null
    },
    borderTop () {
      return this.editingItemable.border && this.editingItemable.border.top
        ? this.editingItemable.border.top
        : { size: 0, color: '' }
    },
    borderRight () {
      return this.editingItemable.border && this.editingItemable.border.right
        ? this.editingItemable.border.right
        : { size: 0, color: '' }
    },
    borderBottom () {
      return this.editingItemable.border && this.editingItemable.border.bottom
        ? this.editingItemable.border.bottom
        : { size: 0, color: '' }
    },
    borderLeft () {
      return this.editingItemable.border && this.editingItemable.border.left
        ? this.editingItemable.border.left
        : { size: 0, color: '' }
    }
  },
  methods: {
    stringToNumber (stringValue) {
      if (!stringValue) return

      return Number(stringValue)
    }
  }
}
</script>
